import { Component, OnInit, ElementRef } from '@angular/core';
import { ModalService } from './modal-service';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html'
})
export class ModalComponent implements OnInit {

  modalRef: ElementRef;

  showModal: boolean;
  outsideClickEnable: boolean;
  counter = 0;

  constructor( private _ModalService: ModalService ) { }

  ngOnInit() {
    // Open/Hide modal window
    this._ModalService.currentState.subscribe(state => {
        this.showModal = state;
        if (this.counter && this.showModal) {
          setTimeout(() => {
            this.outsideClickEnable = true;
          }, 600);
        } else {
          this.outsideClickEnable = false;
        }
        this.counter++;
    });

    // Get modalRef
    this._ModalService.modalRef.subscribe((content) => {
      this.modalRef = content;
    });

    this.showModal = false;
    this.outsideClickEnable = false;
  }

  hideModal() {
    this._ModalService.createModal(false);
  }

}



// WEBPACK FOOTER //
// ./src/app/_common/modal/modal.component.ts